import { ApiStatusError } from '../errors/ApiStatusError';
import type { ResponseShape } from '../types/httpClient';

function isObject(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null;
}

/**
 * The data of a response in the given shape. An envelope with `success: false` throws `ApiStatusError` with the
 * HTTP status 200, so callers handle it like any failed request.
 */
export function unwrapResponse<T>(body: unknown, shape: ResponseShape): T {
    if (shape === 'raw') {
        return body as T;
    }

    if (!isObject(body) || !('data' in body)) {
        throw new ApiStatusError(200, body);
    }

    if (shape === 'envelope' && body.success !== true) {
        throw new ApiStatusError(200, body);
    }

    return body.data as T;
}
